const SESSION_POLL_INTERVAL = 60; // seconds
const REG_PORTAL_INTENT_EXPIRY = 48; // hours
const CASE_REMINDER_EMAIL_THRESHOLD = 24; // hours

export default {
  SESSION_POLL_INTERVAL,
  REG_PORTAL_INTENT_EXPIRY,
  CASE_REMINDER_EMAIL_THRESHOLD,
};
